module.exports = __webpack_public_path__ + "media/images/iconDown__inFrontOfAccent-a238c2483e2f7521f2688f0882d55373.png";